import type { EnrolledType } from '../types';

export interface QueryBuilderParams {
  page: number;
  pageSize: number;
  folio?: string;
  stakeholderIdentifier?: string;
  stakeholderName?: string;
  startDate?: string | null;
  endDate?: string | null;
  businessIdentifier?: string;
  requestId?: string;
  enrolledType?: EnrolledType | null;
  selectedIds?: string[];
  overrideEnrolledType?: string;
  manualOverrideKeys?: string[];
  invoiceOverrideKeys?: string[];
  isEnrolled?: boolean;
}

export type DocumentsAvailablesPayload = Record<string, unknown>;

export const buildDocumentsPayload = (
  params: QueryBuilderParams,
): DocumentsAvailablesPayload => {
  const {
    page,
    pageSize,
    folio,
    stakeholderIdentifier,
    stakeholderName,
    startDate,
    endDate,
    businessIdentifier,
    requestId,
    enrolledType,
    selectedIds = [],
    overrideEnrolledType,
    manualOverrideKeys = [],
    invoiceOverrideKeys = [],
    isEnrolled,
  } = params;

  const hasSearchFilters =
    Boolean(startDate) ||
    Boolean(endDate) ||
    Boolean(stakeholderIdentifier) ||
    Boolean(stakeholderName) ||
    Boolean(folio);

  const effectiveType =
    overrideEnrolledType ??
    enrolledType ??
    (isEnrolled === true ? 'sii' : isEnrolled === false ? 'manual' : undefined);

  const payload: DocumentsAvailablesPayload = {};

  if (folio != null && folio !== '') payload.folio = folio;
  if (stakeholderIdentifier != null && stakeholderIdentifier !== '')
    payload.stakeholderIdentifier = stakeholderIdentifier;
  if (stakeholderName != null && stakeholderName !== '')
    payload.stakeholderName = stakeholderName;
  if (businessIdentifier != null && businessIdentifier !== '')
    payload.businessIdentifier = businessIdentifier;
  if (requestId != null && requestId !== '') payload.requestId = requestId;
  if (page != null) payload.page = page;
  if (pageSize != null) payload.pageSize = pageSize;
  if (startDate != null && startDate !== '') payload.startDate = startDate;
  if (endDate != null && endDate !== '') payload.endDate = endDate;

  const uniqueSelected = Array.from(new Set(selectedIds));
  if (uniqueSelected.length > 0) {
    payload.selectedDocuments = uniqueSelected.join(',');
  }

  if (effectiveType) {
    payload.enrolledType = effectiveType;
  }

  if (
    !hasSearchFilters &&
    effectiveType === 'manual' &&
    manualOverrideKeys.length > 0
  ) {
    payload.newDocuments = manualOverrideKeys.join(',');
  }

  if (
    !hasSearchFilters &&
    effectiveType === 'sii' &&
    invoiceOverrideKeys.length > 0
  ) {
    payload.prioritizedInvoices = invoiceOverrideKeys.join(',');
  }

  return payload;
};
